import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  confirmContractRequest,
  contractsMultipleConfirmationRequest,
  deleteContractsRequest,
  downloadArchivedContractsRequestForCompanies,
  downloadContractErrorsRequest,
  downloadContractsRequest,
  editContractRequest,
  getContractByIdRequest,
  getContractCardsRequest,
  getContractDimonaNumberRequest,
  getContractForDateRequest,
  getContractsCountFromPreviousWeeksRequest,
  getContractsOfAdjacentWeeksRequest,
  getContractsRequestForListView,
  getCostEstimationRequest,
  getWageRequest,
  getWorkingLocationRequest,
  pasteMultipleContractsRequest,
  pasteSingleContractRequest,
  reopenConfirmationRequest,
  saveContractSlotRequest,
  saveMultipleEmployeeContractRequest,
  validateContractSlotHoursRequest,
  validateHoursOnConfirmContractRequest,
  validateHoursOnEditContractRequest,
  validateHoursOnMultipleConfirmContractRequest,
  validateMultipleEmployeeContractRequest,
} from 'api/requests/contract-requests';
import axios from 'axios';
import { getErrorResponseMessage, getValidationMessage } from 'utils/translateValidationMessage';
import { toNumber } from 'lodash';
import { fromConfirmHoursToValidateConfirmHours, fromContractModelToContractRequest } from 'mappers/contracts-mapper';
import { IContractData, IContractToEdit, IContractsCountPerWeek } from 'modules/contracts/types';
import {
  CONTRACTS__DELETE,
  CONTRACTS__DELETE_ERROR,
  CONTRACTS__DELETE_SUCCESS,
  CONTRACTS__DIRECTLY_CARD_TO_COPY,
  CONTRACTS__DIRECTLY_CARD_TO_COPY_ACTION,
  CONTRACTS__DOWNLOAD_COMPANIES_CONTRACTS,
  CONTRACTS__DOWNLOAD_COMPANIES_CONTRACTS_ERROR,
  CONTRACTS__DOWNLOAD_CONTRACTS,
  CONTRACTS__DOWNLOAD_CONTRACTS_ERROR,
  CONTRACTS__DOWNLOAD_CONTRACT_ERRORS,
  CONTRACTS__EDIT_CONTRACT,
  CONTRACTS__EDIT_CONTRACT_ERROR,
  CONTRACTS__GENERAL_LOADING,
  CONTRACTS__GET_ARCHIVED_CONTRACTS_BY_COMPANY_ERROR,
  CONTRACTS__GET_CONTRACTS_COUNT_FROM_PREV_WEEKS,
  CONTRACTS__GET_CONTRACTS_COUNT_FROM_PREV_WEEKS_ERROR,
  CONTRACTS__GET_CONTRACTS_ERROR,
  CONTRACTS__GET_CONTRACTS_LISTVIEW,
  CONTRACTS__GET_CONTRACTS_LISTVIEW_ERROR,
  CONTRACTS__GET_CONTRACTS_LISTVIEW_PAYLOAD,
  CONTRACTS__GET_CONTRACTS_OF_ADJACENT_WEEKS,
  CONTRACTS__GET_CONTRACTS_TOTAL_COUNT,
  CONTRACTS__GET_CONTRACT_BY_ID,
  CONTRACTS__GET_CONTRACT_CARDS,
  CONTRACTS__GET_COST_ESTIMATION,
  CONTRACTS__GET_COST_ESTIMATION_ERROR,
  CONTRACTS__GET_COST_ESTIMATION_PAYLOAD,
  CONTRACTS__GET_DIMONA_CONTRACT_ERROR,
  CONTRACTS__GET_DIMONA_CONTRACT_NUMBER,
  CONTRACTS__GET_DIMONA_CONTRACT_NUMBER_SUCCESS,
  CONTRACTS__MULTIPLE_CONFIRM,
  CONTRACTS__MULTIPLE_CONFIRMATION_ERROR,
  CONTRACTS__MULTIPLE_CONFIRMATION_PAYLOAD,
  CONTRACTS__MULTIPLE_CONFIRMATION_SUCCESS,
  CONTRACTS__REOPEN_CONFIRMATION,
  CONTRACTS__REOPEN_CONFIRMATION_ERROR,
  CONTRACTS__SELECTED_CONTRACTS,
  CONTRACTS__SET_CONTRACTS_COUNT_FROM_PREV_WEEKS,
  CONTRACTS__SET_CONTRACT_DATE_ID_TO_COPY,
  CONTRACTS__SET_ERRORS,
  CONTRACTS__SET_SELECTED_CONTRACTS,
  CONTRACTS__SHOULD_COPY,
  CONTRACTS__SHOULD_COPY_ACTION,
  CONTRACTS__TOGGLE_COPY_MODE_ACTION,
  CONTRACTS__TOO_MANY_CONTRACTS_ERROR,
  CONTRACTS__VALIDATE_HOURS_ON_MULTIPLE_CONFIRM,
  CONTRACT__CLEAR,
  CONTRACT__CONFIRM,
  CONTRACT__CONFIRM_ERROR,
  CONTRACT__GET_CONTRACT_FOR_DATE,
  CONTRACT__GET_CONTRACT_FOR_DATE_ERROR,
  CONTRACT__GET_WAGE,
  CONTRACT__GET_WORKING_LOCATION,
  CONTRACT__PASTE_MULTIPLE_CONTRACTS,
  CONTRACT__PASTE_SINGLE_CONTRACT,
  CONTRACT__SAVE_CONTRACT_SLOT,
  CONTRACT__SAVE_ERROR,
  CONTRACT__SAVE_SUCCESS,
  CONTRACT__SET_CONTRACT,
  CONTRACT__VALIDATE_AND_EDIT,
  CONTRACT__VALIDATE_AND_SAVE_HOURS,
  CONTRACT__VALIDATE_AND_SAVE_MULTIPLE_EMPLOYEE_CONTRACT,
  CONTRACT__VALIDATE_CONTRACT_SLOT_HOURS,
  CONTRACT__VALIDATE_EDIT,
  CONTRACT__VALIDATE_ERROR_MESSAGE,
  CONTRACT__VALIDATE_ERROR_MESSAGE_EXTRA_INFO,
  CONTRACT__VALIDATE_ERROR_MESSAGE_ROW,
  CONTRACT__VALIDATE_HOURS,
  CONTRACT__VALIDATE_SUCCESS,
} from 'store/constants';
import { ContractPageState } from 'store/reducers/contracts-reducer';
import {
  CONTRACTS__ANOTHER_WORKERTYPE_EXISTS_IN_QUARTER,
  CONTRACTS__FLEXI_WORKERTYPE_EXISTS_IN_QUARTER,
} from 'translations/constants';
import { IMultipleEmployeeContractRequest, IPostContractResponse, IWorkingLocationData } from 'types/contract';
import { DimonaContractKeyPair } from 'types/contract/DimonaDetails';
import IConfirmContract from 'types/contract/IConfirmContract';
import IConfirmCostDeclaration from 'types/contract/IConfirmCostDeclaration';
import IConfirmHours from 'types/contract/IConfirmHours';
import { IContractCard } from 'types/contract/IContractCard';
import ContractFilters from 'types/contract/IContractFilters';
import ICostDeclarationRow from 'types/contract/ICostDeclarationRow';
import ISaveContract from 'types/contract/ISaveContract';
import IValidateResponse from 'types/contract/IValidateResponse';
import IWageData from 'types/contract/IWageData';
import logError from 'utils/log-error';

export const setContractsRequestsLoadingAction = createAction<boolean>(CONTRACTS__GENERAL_LOADING);

export const getContractsErrorAction = createAction<boolean>(CONTRACTS__GET_CONTRACTS_ERROR);
export const tooManyContractsAction = createAction<boolean>(CONTRACTS__TOO_MANY_CONTRACTS_ERROR);
export const contractCountAction = createAction<ContractPageState>(CONTRACTS__GET_CONTRACTS_TOTAL_COUNT);

// TODO: REMOVE
// export const getContractsAction = createAsyncThunk(
//   CONTRACTS__GET_CONTRACTS,
//   async (props: { companyId: number; filter: ContractFilters }, thunkApi) => {
//     thunkApi.dispatch(setContractsRequestsLoadingAction(true));
//     thunkApi.dispatch(getContractsErrorAction(false));
//     try {
//       const data = await getContractsRequest({
//         companyId: props?.companyId,
//         filter: props?.filter,
//       });

//       thunkApi.dispatch(getContractsPayloadAction(data.items));
//       // }
//       thunkApi.dispatch(
//         contractCountAction({
//           numberOfResults: data.numberOfResults,
//           pageIndex: data.pageIndex,
//           pageSize: data.pageSize,
//         }),
//       );
//     } catch {
//       thunkApi.dispatch(getContractsErrorAction(true));
//     }
//     thunkApi.dispatch(setContractsRequestsLoadingAction(false));
//   },
// );

export const getContractCardsAction = createAsyncThunk(
  CONTRACTS__GET_CONTRACT_CARDS,
  async (props: { companyId: number; filter: ContractFilters }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const data = await getContractCardsRequest({
        companyId: props?.companyId,
        filter: props?.filter,
      });

      return data;
    } catch {
      thunkApi.dispatch(getContractsErrorAction(true));
      thunkApi.rejectWithValue(undefined);
      return [];
    } finally {
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    }
  },
);

export const getContractsInListViewErrorAction = createAction<boolean>(CONTRACTS__GET_CONTRACTS_LISTVIEW_ERROR);
export const getContractsInListViewPayloadAction = createAction<IContractData[]>(
  CONTRACTS__GET_CONTRACTS_LISTVIEW_PAYLOAD,
);

export const getContractsInListViewAction = createAsyncThunk(
  CONTRACTS__GET_CONTRACTS_LISTVIEW,
  async (props: { companyId: number; filter: ContractFilters }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(getContractsErrorAction(false));
    try {
      const data = await getContractsRequestForListView({
        companyId: props?.companyId,
        filter: props?.filter,
      });

      thunkApi.dispatch(getContractsInListViewPayloadAction(data));
    } catch (error) {
      thunkApi.dispatch(getContractsErrorAction(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const getContractCardsOfAdjacentWeeksAction = createAsyncThunk(
  CONTRACTS__GET_CONTRACTS_OF_ADJACENT_WEEKS,
  async (props: { companyId: number; year: number; week: number; locationId: number | undefined }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const data = await getContractsOfAdjacentWeeksRequest({
        companyId: props?.companyId,
        year: props?.year,
        weekNumber: props?.week,
        locationId: props?.locationId,
      });

      return data;
    } catch {
      thunkApi.dispatch(getContractsErrorAction(true));
      thunkApi.rejectWithValue(undefined);
      return [];
    } finally {
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    }
  },
);

export const getCostEstimationErrorAction = createAction<boolean>(CONTRACTS__GET_COST_ESTIMATION_ERROR);
export const getCostEstimationPayloadAction = createAction<any>(CONTRACTS__GET_COST_ESTIMATION_PAYLOAD);

export const getCostEstimationAction = createAsyncThunk(
  CONTRACTS__GET_COST_ESTIMATION,
  async (props: { companyId: number; weekNumber: number; year: number }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(getCostEstimationErrorAction(false));
    try {
      const costEstimations = await getCostEstimationRequest({
        companyId: props?.companyId,
        weekNumber: props.weekNumber,
        year: props.year,
      });
      thunkApi.dispatch(getCostEstimationPayloadAction(costEstimations));
    } catch {
      thunkApi.dispatch(getCostEstimationErrorAction(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const saveContractSuccessAction = createAction<boolean>(CONTRACT__SAVE_SUCCESS);
export const saveContractErrorAction = createAction<boolean>(CONTRACT__SAVE_ERROR);

export const validateContractSuccessAction = createAction<boolean>(CONTRACT__VALIDATE_SUCCESS);
export const validateContractErrorMessageAction = createAction<string>(CONTRACT__VALIDATE_ERROR_MESSAGE);
export const validateContractErrorMessageExtraInfoAction = createAction<string>(
  CONTRACT__VALIDATE_ERROR_MESSAGE_EXTRA_INFO,
);
export const validateContractErrorMessageRowAction = createAction<number>(CONTRACT__VALIDATE_ERROR_MESSAGE_ROW);

export const clearContractAction = createAction<void>(CONTRACT__CLEAR);

export const getWageAction = createAsyncThunk(CONTRACT__GET_WAGE, async (wageData: IWageData, thunkApi) => {
  thunkApi.dispatch(setContractsRequestsLoadingAction(true));
  try {
    const response = await getWageRequest(wageData);
    return response;
  } catch (error) {
    logError(error);
  } finally {
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  }
  return 0;
});

export const getWorkingLocationAction = createAsyncThunk(
  CONTRACT__GET_WORKING_LOCATION,
  async (props: IWorkingLocationData, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const response = await getWorkingLocationRequest(props);
      return response;
    } catch (error) {
      logError(error);
    } finally {
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    }
    return '';
  },
);

export const getContractForDateError = createAction<boolean>(CONTRACT__GET_CONTRACT_FOR_DATE_ERROR);
export const setContract = createAction<IConfirmContract>(CONTRACT__SET_CONTRACT);

export const getContractForDate = createAsyncThunk(
  CONTRACT__GET_CONTRACT_FOR_DATE,
  async (props: { contractDateId: number; companyId: string }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(getContractForDateError(false));
    try {
      const response = await getContractForDateRequest({
        contractDateId: props.contractDateId,
        companyId: props.companyId,
      });

      thunkApi.dispatch(setContract(response));
    } catch (error) {
      thunkApi.dispatch(getContractForDateError(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

const generateErrorsToDispatch = (err: any) => {
  const auxErr: { type: string; contractId: number } = { type: '', contractId: null };
  if (err.errorMessage.includes('DELETE_PAST_CONTRACT') || err.errorMessage === 'Invalid contract date id.') {
    auxErr.type = 'deletePastContract';
    const regex = /with id (.*)./;
    const str = err.error;
    const result = regex.exec(str);
    auxErr.contractId = toNumber(result[1]);
  } else if (err.errorMessage.includes('SIGNED_CONTRACT_ERROR')) {
    auxErr.type = 'signedPastContract';
    const regex = /with id (.*)./;
    const str = err.error;
    const result = regex.exec(str);
    auxErr.contractId = toNumber(result[1]);
  } else auxErr.type = 'default';
  return auxErr;
};

export const setErrors = createAction<any>(CONTRACTS__SET_ERRORS);

export const confirmContractError = createAction<boolean>(CONTRACT__CONFIRM_ERROR);

export const confirmContract = createAsyncThunk(
  CONTRACT__CONFIRM,
  async (
    props: { confirmHours: IConfirmHours; companyId: string; confirmCostDeclarations: ICostDeclarationRow[] },
    thunkApi,
  ) => {
    thunkApi.dispatch(confirmContractError(false));
    thunkApi.dispatch(setErrors([]));

    const costDeclarations: IConfirmCostDeclaration[] = props.confirmCostDeclarations.map(costDeclaration => {
      return {
        costDeclarationId: toNumber(costDeclaration.costDeclarationId),
        amount: costDeclaration.amount,
        quantity: costDeclaration.quantity,
      };
    });

    const hours = props.confirmHours;
    hours.confirmedCostDeclarations = costDeclarations;
    hours.costCenterId = toNumber(props.confirmHours.costCenterId);

    try {
      await confirmContractRequest({
        contractHours: hours,
        companyId: props.companyId,
      });
    } catch (error) {
      thunkApi.dispatch(
        setErrors([
          {
            type: 'default',
          },
        ]),
      );
      thunkApi.dispatch(confirmContractError(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const validateHoursOnConfirmContractAction = createAsyncThunk(
  CONTRACT__VALIDATE_HOURS,
  async (
    props: {
      confirmHours: IConfirmHours;
      employeeId: number;
      functionId: number;
      companyId: string;
    },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(validateContractSuccessAction(false));
    try {
      const validateHours = fromConfirmHoursToValidateConfirmHours(
        props.confirmHours,
        props.employeeId,
        props.companyId,
        props.functionId,
      );
      const response: IValidateResponse = await validateHoursOnConfirmContractRequest({
        validateHours,
        companyId: props.companyId,
      });
      thunkApi.dispatch(validateContractSuccessAction(response.success));
      thunkApi.dispatch(validateContractErrorMessageAction(getValidationMessage(response)));
      thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(response.errorMessageDetails));
      thunkApi.dispatch(validateContractErrorMessageRowAction(response.rowNumber));
    } catch (error) {
      thunkApi.dispatch(validateContractSuccessAction(false));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const setContractsMultipleConfimrationPayload = createAction<any>(CONTRACTS__MULTIPLE_CONFIRMATION_PAYLOAD);
export const setContractsMultipleConfirmationSucces = createAction<boolean>(CONTRACTS__MULTIPLE_CONFIRMATION_SUCCESS);

export const validateHoursOnMultipleConfirmContractAction = createAsyncThunk(
  CONTRACTS__VALIDATE_HOURS_ON_MULTIPLE_CONFIRM,
  async (
    props: {
      contractsData: any[];
      companyId: number;
    },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(setContractsMultipleConfirmationSucces(false));
    try {
      const response: IValidateResponse = await validateHoursOnMultipleConfirmContractRequest({
        contractsData: props.contractsData,
        companyId: props.companyId,
      });
      thunkApi.dispatch(setContractsMultipleConfirmationSucces(true));
      thunkApi.dispatch(setContractsMultipleConfimrationPayload(response));
    } catch (error) {
      thunkApi.dispatch(setContractsMultipleConfirmationSucces(false));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const setMultipleConfirmationError = createAction<boolean>(CONTRACTS__MULTIPLE_CONFIRMATION_ERROR);

export const multipleConfirmContractsAction = createAsyncThunk(
  CONTRACTS__MULTIPLE_CONFIRM,
  async (
    props: {
      contractsData: any[];
      companyId: number;
      year: number;
      weekNumber: number;
    },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(setMultipleConfirmationError(false));
    let failedItems: Record<string, string> = {};
    try {
      failedItems = await contractsMultipleConfirmationRequest({
        contractsData: props.contractsData,
        companyId: props.companyId,
      });
    } catch (error) {
      thunkApi.dispatch(setMultipleConfirmationError(true));
      thunkApi.dispatch(
        setErrors([
          {
            type: 'default',
          },
        ]),
      );
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    return failedItems;
  },
);

export const editContractErrorAction = createAction<boolean>(CONTRACTS__EDIT_CONTRACT_ERROR);

export const validateContractEditAction = createAsyncThunk(
  CONTRACT__VALIDATE_EDIT,
  async (
    props: {
      contract: any;
      companyId: number;
    },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const response: IValidateResponse = await validateHoursOnEditContractRequest({
        contract: props.contract,
        companyId: props.companyId,
      });
      thunkApi.dispatch(validateContractSuccessAction(response.success));
      thunkApi.dispatch(validateContractErrorMessageAction(getValidationMessage(response)));
      thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(response.errorMessageDetails));
      thunkApi.dispatch(validateContractErrorMessageRowAction(response.rowNumber));
    } catch {
      thunkApi.dispatch(validateContractSuccessAction(false));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const editContractAction = createAsyncThunk(
  CONTRACTS__EDIT_CONTRACT,
  async (props: { companyId: number; contract: IContractToEdit }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(editContractErrorAction(false));
    try {
      await editContractRequest({
        companyId: props.companyId,
        contract: props.contract,
      });
    } catch (error) {
      thunkApi.dispatch(editContractErrorAction(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const deleteContractsSuccessAction = createAction<boolean>(CONTRACTS__DELETE_SUCCESS);
export const deleteContractsErrorAction = createAction<boolean>(CONTRACTS__DELETE_ERROR);
export const deleteContractsAction = createAsyncThunk(
  CONTRACTS__DELETE,
  async (
    props: {
      companyId: number;
      contractsIds: number[];
      year: number;
      weekNumber: number;
      confirmedDeleteSigned?: boolean;
    },
    thunkApi,
  ) => {
    const { companyId, contractsIds, year, weekNumber, confirmedDeleteSigned } = props;
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(deleteContractsErrorAction(false));
    thunkApi.dispatch(deleteContractsSuccessAction(false));

    try {
      const response = await deleteContractsRequest({
        companyId,
        contractsIds,
        confirmedDeleteSigned,
      });

      if (response) {
        let errToSend: any[] = [];
        response.forEach((err: any) => {
          errToSend = [...errToSend, generateErrorsToDispatch(err)];
        });

        thunkApi.dispatch(setErrors(errToSend));
      }
      thunkApi.dispatch(deleteContractsSuccessAction(true));
    } catch (error) {
      thunkApi.dispatch(deleteContractsErrorAction(true));
      thunkApi.dispatch(
        setErrors([
          {
            type: 'default',
          },
        ]),
      );
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const deleteContractDashboardAction = createAsyncThunk(
  CONTRACTS__DELETE,
  async (props: { companyId: number; contractsIds: number[]; year: number; weekNumber: number }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(deleteContractsErrorAction(false));

    try {
      const response = await deleteContractsRequest({
        companyId: props.companyId,
        contractsIds: props.contractsIds,
        confirmedDeleteSigned: false,
      });
      if (response) {
        let errToSend: any[] = [];
        response.forEach((err: any) => {
          errToSend = [...errToSend, generateErrorsToDispatch(err)];
        });
      }
    } catch (error) {
      thunkApi.dispatch(deleteContractsErrorAction(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const setSelectedContracts = createAction<IContractCard[]>(CONTRACTS__SET_SELECTED_CONTRACTS);
export const selectedContractsAction = createAsyncThunk(
  CONTRACTS__SELECTED_CONTRACTS,
  async (props: { selectedContracts: IContractCard[] }, thunkApi) => {
    thunkApi.dispatch(setSelectedContracts(props.selectedContracts));
  },
);

export const setShouldCopyContracts = createAction<boolean>(CONTRACTS__SHOULD_COPY);
export const shouldCopyAction = createAsyncThunk(
  CONTRACTS__SHOULD_COPY_ACTION,
  async (props: { copy: boolean }, thunkApi) => {
    thunkApi.dispatch(setShouldCopyContracts(props.copy));
  },
);

export const setDirectlyCardToCopy = createAction<number>(CONTRACTS__DIRECTLY_CARD_TO_COPY);
export const directlyCardToCopyAction = createAsyncThunk(
  CONTRACTS__DIRECTLY_CARD_TO_COPY_ACTION,
  async (props: { id: number }, thunkApi) => {
    thunkApi.dispatch(setDirectlyCardToCopy(props.id));
  },
);

export const toggleCopyModeAction = createAction<void>(CONTRACTS__TOGGLE_COPY_MODE_ACTION);

export const setContractCardToCopyAction = createAction<IContractCard>(CONTRACTS__SET_CONTRACT_DATE_ID_TO_COPY);

export const getContractsCountFromPreviousWeeksErrorAction = createAction<boolean>(
  CONTRACTS__GET_CONTRACTS_COUNT_FROM_PREV_WEEKS_ERROR,
);
export const setContractsCountFromPreviousWeeksAction = createAction<IContractsCountPerWeek[]>(
  CONTRACTS__SET_CONTRACTS_COUNT_FROM_PREV_WEEKS,
);

export const getContractsCountFromPreviousWeeksAction = createAsyncThunk(
  CONTRACTS__GET_CONTRACTS_COUNT_FROM_PREV_WEEKS,
  async (props: { companyId?: number; year: number; weekNumber: number; locationId: number }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(getContractsCountFromPreviousWeeksErrorAction(false));
    try {
      const response = await getContractsCountFromPreviousWeeksRequest({
        companyId: props?.companyId,
        year: props.year,
        weekNumber: props.weekNumber,
        locationId: props.locationId,
      });
      thunkApi.dispatch(setContractsCountFromPreviousWeeksAction(response));
    } catch (error) {
      thunkApi.dispatch(getContractsCountFromPreviousWeeksErrorAction(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const downloadContractsErrorAction = createAction<boolean>(CONTRACTS__DOWNLOAD_CONTRACTS_ERROR);

export const downloadContractAction = createAsyncThunk(
  CONTRACTS__DOWNLOAD_CONTRACTS,
  async (props: { companyId: number; ids: number[]; type: string }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(downloadContractsErrorAction(false));
    try {
      const response = await downloadContractsRequest({
        contractsData: {
          companyId: props.companyId,
          type: props.type,
          contractIds: props.ids,
        },
        companyId: props.companyId,
      });

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      const date = new Date().toISOString().split('T')[0];
      link.href = url;
      link.setAttribute('download', `${props.type}_contracts_${date}.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      thunkApi.dispatch(downloadContractsErrorAction(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const downloadContractErrorsAction = createAsyncThunk(
  CONTRACTS__DOWNLOAD_CONTRACT_ERRORS,
  async (props: { errors: IPostContractResponse[] }, thunkApi) => {
    const { errors } = props;
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const response = await downloadContractErrorsRequest({
        errors,
      });

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      const date = new Date().toISOString().split('T')[0];
      link.href = url;
      link.setAttribute('download', `contract_errors_${date}.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      logError(error);
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const downloadArchivedContractsForCompanyErrorAction = createAction<boolean>(
  CONTRACTS__DOWNLOAD_COMPANIES_CONTRACTS_ERROR,
);

export const downloadArchivedContractsForCompanyAction = createAsyncThunk(
  CONTRACTS__DOWNLOAD_COMPANIES_CONTRACTS,
  async (
    props: { companyPcPairList: number[][]; type: string; year: number; week: number; paritairComites?: number[] },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(downloadArchivedContractsForCompanyErrorAction(false));
    try {
      const response = await downloadArchivedContractsRequestForCompanies({
        companyPcPairList: props.companyPcPairList,
        type: props.type,
        year: props.year,
        week: props.week,
      });

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      const date = new Date().toISOString().split('T')[0];
      link.href = url;
      link.setAttribute('download', `${props.year}_${props.week}_contracts_${date}.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      thunkApi.dispatch(downloadContractsErrorAction(true));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const saveContractSlotAction = createAsyncThunk(
  CONTRACT__SAVE_CONTRACT_SLOT,
  async (
    props: {
      saveContractSlot: ISaveContract;
      quantity: number;
    },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const contractRequest = fromContractModelToContractRequest(
        props.saveContractSlot.contract,
        props.saveContractSlot.weekDaysRows,
        props.saveContractSlot.week,
        props.saveContractSlot.year,
        props.saveContractSlot.wage,
        props.saveContractSlot.workingLocation,
      );

      await saveContractSlotRequest({
        contract: contractRequest,
        companyId: props.saveContractSlot.companyId,
        quantity: props.quantity,
      });
      thunkApi.dispatch(saveContractSuccessAction(true));
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
      return true;
    } catch {
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
      return false;
    }
  },
);

export const pasteSingleContractAction = createAsyncThunk(
  CONTRACT__PASTE_SINGLE_CONTRACT,
  async (
    props: {
      contractDateId: number;
      date: string;
      companyId: number;
    },
    thunkApi,
  ) => {
    const { contractDateId, date, companyId } = props;
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      await pasteSingleContractRequest({
        contractDateId,
        date,
        companyId,
      });
    } catch (error) {
      logError(error);
      if (axios.isAxiosError(error) && error.response) {
        if (error.response.status === 400) {
          // A plain string body: a translation key, or for the minors break rules the sentence the API resolved.
          const { data } = error.response;
          thunkApi.dispatch(
            validateContractErrorMessageAction(typeof data === 'string' ? data : getErrorResponseMessage(error)),
          );
        }
      }
    } finally {
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    }
  },
);

export const pasteMultipleContractsAction = createAsyncThunk(
  CONTRACT__PASTE_MULTIPLE_CONTRACTS,
  async (
    props: {
      contractIds: number[];
      weeksToPasteTo: number[];
      companyId: number;
    },
    thunkApi,
  ) => {
    const { contractIds, weeksToPasteTo, companyId } = props;
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    const errorResponses: IPostContractResponse[] = [];
    try {
      const responseList = await pasteMultipleContractsRequest({
        contractIds,
        weeksToPasteTo,
        companyId,
      });
      if (responseList.some(res => !res.success)) {
        responseList.forEach(res => {
          if (!res.success) {
            errorResponses.push(res);
          }
        });
      }
    } catch (error) {
      logError(error);
    } finally {
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    }
    return errorResponses;
  },
);

export const validateAndSaveContractSlotHoursAction = createAsyncThunk(
  CONTRACT__VALIDATE_CONTRACT_SLOT_HOURS,
  async (
    props: {
      saveContractSlot: ISaveContract;
      quantity: number;
    },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const contractRequest = fromContractModelToContractRequest(
        props.saveContractSlot.contract,
        props.saveContractSlot.weekDaysRows,
        props.saveContractSlot.week,
        props.saveContractSlot.year,
        props.saveContractSlot.wage,
        props.saveContractSlot.workingLocation,
      );

      const response: IValidateResponse = await validateContractSlotHoursRequest({
        contract: contractRequest,
        companyId: props.saveContractSlot.companyId,
      });
      if (!response.success) {
        thunkApi.dispatch(validateContractSuccessAction(false));
        thunkApi.dispatch(validateContractErrorMessageAction(getValidationMessage(response)));
        thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(response.errorMessageDetails));
        thunkApi.dispatch(validateContractErrorMessageRowAction(response.rowNumber));
        thunkApi.dispatch(setContractsRequestsLoadingAction(false));
        return false;
      }
      thunkApi.dispatch(saveContractSlotAction(props));
      thunkApi.dispatch(validateContractSuccessAction(true));
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
      return true;
    } catch (error) {
      thunkApi.dispatch(validateContractSuccessAction(false));
    }
    return false;
  },
);

export const validateAndSaveMultipleEmployeeContractAction = createAsyncThunk(
  CONTRACT__VALIDATE_AND_SAVE_MULTIPLE_EMPLOYEE_CONTRACT,
  async (
    props: {
      contract: IMultipleEmployeeContractRequest;
      companyId: number;
    },
    thunkApi,
  ) => {
    const { contract, companyId } = props;
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(validateContractSuccessAction(false));

    try {
      const validation = await validateMultipleEmployeeContractRequest({
        contract,
        companyId,
      });
      const { success, messageTranslationKey, rowNumber, errorMessageDetails } = validation;

      if (!success) {
        await thunkApi.dispatch(validateContractSuccessAction(false));
        await thunkApi.dispatch(validateContractErrorMessageAction(getValidationMessage(validation)));
        await thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(errorMessageDetails));
        await thunkApi.dispatch(validateContractErrorMessageRowAction(rowNumber));
        if (
          messageTranslationKey === CONTRACTS__ANOTHER_WORKERTYPE_EXISTS_IN_QUARTER ||
          messageTranslationKey === CONTRACTS__FLEXI_WORKERTYPE_EXISTS_IN_QUARTER
        ) {
          await thunkApi.dispatch(validateContractErrorMessageRowAction(-1));
        }
        thunkApi.dispatch(setContractsRequestsLoadingAction(false));

        return false;
      }

      await saveMultipleEmployeeContractRequest({
        contract,
        companyId,
      });

      thunkApi.dispatch(saveContractSuccessAction(true));
      await thunkApi.dispatch(validateContractErrorMessageRowAction(rowNumber));
      await thunkApi.dispatch(validateContractErrorMessageAction(''));
      await thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(''));

      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
      return true;
    } catch (error) {
      logError(error);
      thunkApi.dispatch(validateContractSuccessAction(false));
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    }
    return false;
  },
);

export const validateAndSaveEditContractAction = createAsyncThunk(
  CONTRACT__VALIDATE_AND_EDIT,
  async (
    props: {
      contract: any;
      companyId: number;
    },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(editContractErrorAction(false));
    try {
      const result = await validateHoursOnEditContractRequest({
        contract: props.contract,
        companyId: props.companyId,
      });

      if (!result.success) {
        thunkApi.dispatch(validateContractSuccessAction(result.success));
        thunkApi.dispatch(validateContractErrorMessageAction(getValidationMessage(result)));
        thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(result.errorMessageDetails));
        thunkApi.dispatch(validateContractErrorMessageRowAction(result.rowNumber));
        thunkApi.dispatch(setContractsRequestsLoadingAction(false));
        return false;
      }

      thunkApi.dispatch(validateContractSuccessAction(true));
      thunkApi.dispatch(validateContractErrorMessageAction(''));
      thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(''));
      thunkApi.dispatch(validateContractErrorMessageRowAction(null));

      // trigger edit contract
      await editContractRequest({
        companyId: props.companyId,
        contract: props.contract,
      });

      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
      return true;
    } catch {
      thunkApi.dispatch(validateContractSuccessAction(false));
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
      return false;
    }
  },
);

export const getArchivedContractsByCompanyErrorAction = createAction<boolean>(
  CONTRACTS__GET_ARCHIVED_CONTRACTS_BY_COMPANY_ERROR,
);

export const validateAndConfirmContract = createAsyncThunk(
  CONTRACT__VALIDATE_AND_SAVE_HOURS,
  async (
    props: {
      confirmHours: IConfirmHours;
      employeeId: number;
      functionId: number;
      companyId: string;
      confirmCostDeclarations: ICostDeclarationRow[];
    },
    thunkApi,
  ) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    thunkApi.dispatch(validateContractSuccessAction(false));

    thunkApi.dispatch(confirmContractError(false));
    thunkApi.dispatch(setErrors([]));

    const costDeclarations: IConfirmCostDeclaration[] = props.confirmCostDeclarations.map(costDeclaration => {
      return {
        costDeclarationId: toNumber(costDeclaration.costDeclarationId),
        amount: costDeclaration.amount,
        quantity: costDeclaration.quantity,
      };
    });

    const hours = props.confirmHours;
    hours.confirmedCostDeclarations = costDeclarations;
    hours.costCenterId = toNumber(props.confirmHours.costCenterId);

    try {
      const validateHours = fromConfirmHoursToValidateConfirmHours(
        props.confirmHours,
        props.employeeId,
        props.companyId,
        props.functionId,
      );

      const response = await validateHoursOnConfirmContractRequest({
        validateHours,
        companyId: props.companyId,
      });

      thunkApi.dispatch(validateContractSuccessAction(response.success));
      thunkApi.dispatch(validateContractErrorMessageAction(getValidationMessage(response)));
      thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(response.errorMessageDetails));
      thunkApi.dispatch(validateContractErrorMessageRowAction(response.rowNumber));

      if (!response.success) {
        thunkApi.dispatch(setContractsRequestsLoadingAction(false));
        return false;
      }

      await confirmContractRequest({
        contractHours: hours,
        companyId: props.companyId,
      });
    } catch (error) {
      logError(error);
      thunkApi.dispatch(validateContractSuccessAction(false));

      const errorMessage = getErrorResponseMessage(error);
      if (axios.isAxiosError(error) && error.response && errorMessage !== 'An unexpected error occurred') {
        thunkApi.dispatch(validateContractErrorMessageAction(errorMessage));
        thunkApi.dispatch(validateContractErrorMessageExtraInfoAction(''));
      } else {
        thunkApi.dispatch(
          setErrors([
            {
              type: 'default',
            },
          ]),
        );
      }

      thunkApi.dispatch(confirmContractError(true));
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
      return false;
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    return true;
  },
);

export const setReopenConfirmationErrorAction = createAction<boolean>(CONTRACTS__REOPEN_CONFIRMATION_ERROR);

export const reopenConfirmationAction = createAsyncThunk(
  CONTRACTS__REOPEN_CONFIRMATION,
  async (props: { companyId: number; contractDateId: number; year: number; weekNumber: number }, thunkApi) => {
    const { companyId, contractDateId, year, weekNumber } = props;
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      await reopenConfirmationRequest({
        contractDateId,
        companyId,
      });
    } catch (error) {
      setReopenConfirmationErrorAction(true);
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const getDimonaNumberErrorAction = createAction<DimonaContractKeyPair>(CONTRACTS__GET_DIMONA_CONTRACT_ERROR);
export const getDimonaNumberSuccessAction = createAction<DimonaContractKeyPair>(
  CONTRACTS__GET_DIMONA_CONTRACT_NUMBER_SUCCESS,
);

export const getDimonaNumberAction = createAsyncThunk(
  CONTRACTS__GET_DIMONA_CONTRACT_NUMBER,
  async (props: { companyId: number; contractId: number }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const response = await getContractDimonaNumberRequest({
        companyId: props?.companyId,
        contractId: props?.contractId,
      });

      const result: DimonaContractKeyPair = {
        contractId: props?.contractId,
        dimonaId: response.dimonaId,
        hasDimonaError: !!response.dimonaError && response.dimonaError !== '',
      };
      if (response.dimonaId) thunkApi.dispatch(getDimonaNumberSuccessAction(result));
      else {
        result.dimonaId = response.dimonaError;
        thunkApi.dispatch(getDimonaNumberErrorAction(result));
      }
    } catch (error: any) {
      const errorData: DimonaContractKeyPair = {
        contractId: props?.contractId,
        dimonaId: error?.message,
      };
      thunkApi.dispatch(getDimonaNumberErrorAction(errorData));
    }
    thunkApi.dispatch(setContractsRequestsLoadingAction(false));
  },
);

export const getContractByIdAction = createAsyncThunk(
  CONTRACTS__GET_CONTRACT_BY_ID,
  async (props: { companyId: number; contractId: number }, thunkApi) => {
    thunkApi.dispatch(setContractsRequestsLoadingAction(true));
    try {
      const response = await getContractByIdRequest({
        companyId: props?.companyId,
        contractId: props?.contractId,
      });

      return response;
    } catch {
      return thunkApi.rejectWithValue('Error fetching contract by ID');
    } finally {
      thunkApi.dispatch(setContractsRequestsLoadingAction(false));
    }
  },
);
